import { ColorContext, SetColorContext, ThemesListContext } from 'App';
import React, { useContext, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { FaX } from 'react-icons/fa6';

const ThemeSelectorTool = ({ setSelectedTheme, setShowThemeSelector }) => {
  const themes = useContext(ThemesListContext);
  const colors = useContext(ColorContext);
  const setColors = useContext(SetColorContext);

  const themeHandler = (theme, i) => {
    setSelectedTheme(theme);

    setColors({ ...colors, ...theme.value });
    setSelectedIndex(i);
  };
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [expanded, setExpanded] = useState(false);
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 80,
        left: 15,
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        padding: 10,
        background: colors.primaryHighlight,
        color: colors.fontColor,
        zIndex: 1300,
        width: 190,
        cursor: 'pointer',
        borderRadius: 10,
      }}
      onClick={() => setExpanded(!expanded)}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <button>{expanded ? <FaChevronDown /> : <FaChevronUp />}</button>
        🎨 Themes{' '}
        <button onClick={() => setShowThemeSelector(false)}>
          <FaX />
        </button>
      </div>
      {expanded &&
        themes.map((theme, i) => (
          <div
            style={{
              background: selectedIndex === i ? colors.primaryShadow : colors.primaryHighlight,
              borderRadius: 5,
              padding: 10,
            }}
          >
            <button style={{ width: '100%' }} onClick={() => themeHandler(theme, i)}>
              {theme.name}
              <div
                style={{
                  width: '100%',
                  height: 25,
                  background: `linear-gradient(90deg, ${Object.keys(theme.value)
                    .map((item) => theme.value[item])
                    .join(', ')})`,
                }}
              ></div>
            </button>
          </div>
        ))}
    </div>
  );
};

export default ThemeSelectorTool;
